<h1 mat-dialog-title>Delete Package Config</h1>
<div mat-dialog-content>Are you sure do you like to delete?</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>OK</button>
  <button mat-button mat-dialog-close>Cancel</button>
</div>
